<template>
  <div>
    <p>分析対象のレビューは最大100件（PC10ページ分）となります。</p>
    <div class="analysis-filter-form grid gap-6 mb-5 text-center">
      <div class="text-xl rounded-lg">
        点数
      </div>
      <div class="text-xl rounded-lg">
        バリエーション
      </div>
      <div class="text-xl rounded-lg">
        期間
      </div>
      <div class="text-3xl col-start-4 row-start-1 row-end-3 rounded-lg grid items-center">
        <div><animated-number :model-value="reviewCount" /> 件</div>
        <div><animated-number :model-value="wordCount" /> 文字</div>
      </div>
      <div class="rounded-lg">
        <vs-checkbox
          v-for="r in [5, 4, 3, 2, 1]"
          :key="r"
          v-model="rates"
          :vs-value="r"
          class="my-2"
          :checked="(rate.indexOf(r) >= 0)"
          :disabled="(rate.indexOf(r) == -1)"
        >
          {{ r }}
        </vs-checkbox>
      </div>
      <div class="rounded-lg overflow-x-auto">
        <span v-if="(variation.length == 1 && variation[0] == '不明')">なし</span>
        <span v-else>
          <vs-checkbox
            v-for="v in variation"
            :key="v"
            v-model="variations"
            :vs-value="v"
            class="whitespace-no-wrap my-2"
            :checked="true"
          >{{ v }}</vs-checkbox>
        </span>
      </div>
      <div class="bg-white">
        <DateRanges
          v-model:start-day="startDay"
          v-model:end-day="endDay"
          :is-past-year-mode="true"
          @on-change="onDateChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DateRanges from '@/components/DateRanges'
import AnimatedNumber from '@/components/AnimatedNumber'

/**
 * レビューの最小の数
 */
const REVIEW_COUNT_LIMIT = 10

export default {
  name: 'ReviewAnalysisFilterForm',
  components: {
    AnimatedNumber,
    DateRanges
  },
  props: {
    product: {
      type: Array,
      required: true
    },
    rate: {
      type: Array,
      required: true
    },
    date: {
      type: Array,
      required: true
    },
    variation: {
      type: Array,
      required: true
    },
    filter: {
      type: Object,
      default: null
    },
    submitDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:filter',
    'update:submit-disabled'
  ],
  data () {
    return {
      rates: [],
      variations: [],
      reviewCount: 0,
      wordCount: 0,
      defaultStartDay: null,
      defaultEndDay: null,
      startDay: null,
      endDay: null
    }
  },
  watch: {
    rates: {
      handler () {
        this.changeFilter()
      },
      deep: true
    },
    variations: {
      handler () {
        this.changeFilter()
      },
      deep: true
    },
    product: {
      handler (val) {
        if (Array.isArray(val)) {
          this.rates = this.rate
          this.variations = this.variation
          const count = this.getCount(val)
          this.reviewCount = count.review
          this.wordCount = count.word
          this.defaultStartDay = moment(this.date[0]).format()
          this.defaultEndDay = moment(this.date[this.date.length - 1]).format()
          this.startDay = this.defaultStartDay
          this.endDay = this.defaultEndDay
          this.$emit('update:filter', this.createFilter())
        }
      },
      deep: true
    },
    reviewCount: {
      handler (val) {
        if (val < REVIEW_COUNT_LIMIT) {
          this.$emit('update:submit-disabled', true)
        } else {
          this.$emit('update:submit-disabled', false)
        }
      }
    }
  },
  methods: {
    onDateChange ({ start, end }) {
      // 更新
      this.startDay = moment(start).format()
      this.endDay = moment(end).format()
      // 更新時はデフォルト値も更新
      this.defaultStartDay = this.startDay
      this.defaultEndDay = this.endDay
      // フィルター呼び出し
      this.changeFilter()
    },
    changeFilter () {
      const startDay = moment(this.startDay)
      const endDay = moment(this.endDay)
      const product = this.product.reduce((dist, p) => {
        if (this.rates.indexOf(p.rate) === -1) return dist
        if (this.variations.indexOf(p.variation) === -1) return dist
        if (moment(p.date).isBefore(startDay) || moment(p.date).isAfter(endDay)) return dist
        return dist.concat([p])
      }, [])
      const count = this.getCount(product)
      this.reviewCount = count.review
      this.wordCount = count.word
      this.$emit('update:filter', this.createFilter())
    },
    getCount (product) {
      return {
        review: product.length,
        word: product.reduce((dist, p) => {
          dist += p.title.length + 1 + p.body.length
          return dist
        }, 0)
      }
    },
    createFilter () {
      return {
        rate: this.rates,
        start: moment(this.startDay).format('YYYY-MM-DD'),
        end: moment(this.endDay).format('YYYY-MM-DD'),
        variation: this.variations.map(v => { return (v === '不明') ? null : v })
      }
    }
  }
}
</script>

<style scoped>
.analysis-filter-form {
  grid-template-columns: 55px 1fr 260px 170px;
}
.analysis-filter-form > div {
  padding: 5px;
}
.analysis-filter-form > div {
  background-color: #ddd;
}
.analysis-filter-form :deep(button.vs-component.vs-button) {
  padding: 0.7rem 0.7rem !important;
  font-size: 0.8rem !important;
}
.analysis-filter-form :deep(span.vs-checkbox) {
  padding: 8px;
}
</style>
